import styled from 'styled-components';

import {
  EmptyStateWrapper as BaseEmptyStateWrapper,
  HeaderText as BaseHeaderText,
  ImageWrapper as BaseImageWrapper,
} from './base';

export * from './base';

export const EmptyStateWrapper = styled(BaseEmptyStateWrapper)`
  color: ${Styles.color.black};
`;

export const HeaderText = styled(BaseHeaderText)`
  font-size: 1.625rem;
`;

export const ImageWrapper = styled(BaseImageWrapper)`
  svg {
    fill: ${Styles.color.primary};
  }
`;
